module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/224.8c2433ab.png";